import React, { useState } from "react";
import axios from "axios";


const handleDisplayInput = (
  domain,
  setIsEditing,
  setSelectedDomain,
  setDomainName,
  setDecision
) => {
  setIsEditing(true);
  setSelectedDomain(domain);
  setDomainName(domain.domainname);
  setDecision(domain.decisiontype2);
};

const handleCloseInput = (
  setIsEditing,
  setSelectedDomain,
  setDomainName,
  setDecision
) => {
  setIsEditing(false);
  setSelectedDomain(null);
  setDomainName("");
  setDecision("");
};

const handleUpdate = async (
  selectedDomain,
  domainName,
  decision,
  setDomainError,
  setSuccess
) => {
  const accessToken = localStorage.getItem("accessToken");
  const data = {
    domainname: domainName,
    decisiontype2: decision,
  };

  try {
    const response = await axios.patch(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}domains/${selectedDomain.domainid}/update/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.data?.error) {
      setDomainError("Error while updating domain!");
    } else {
      setSuccess("Domain Updated!");

      setTimeout(() => {
        setSuccess(null);
      }, "2000");
    }
  } catch (error) {
    if (error.response) {
      setDomainError("Error while updating domain!");
      setTimeout(() => {
        setDomainError(null);
      }, "2000");
    } else if (error.request) {
      console.error("Network Error: No response received");
      setDomainError("Error while updating domain!");
      setTimeout(() => {
        setDomainError(null);
      }, "2000");
    } else {
      console.error("Unexpected Error:", error.message);
      setDomainError("Error while updating domain!");
      setTimeout(() => {
        setDomainError(null);
      }, "2000");
    }
  }
};

export default function DomainManager({ domains, selectedCase, setSuccess }) {
  const [isEditing, setIsEditing] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [newDomainName, setNewDomainName] = useState("");
  const [newDecision, setNewDecision] = useState("");
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [domainName, setDomainName] = useState("");
  const [decision, setDecision] = useState("");
  const [domainError, setDomainError] = useState(null);
  const [domainSuccess, setDomainSuccess] = useState(null);

  const handleDomainNameChange = (event) => {
    setDomainName(event.target.value);
  };

  const handleDecisionChange = (event) => {
    setDecision(event.target.value);
  };
  const handleNewDomainNameChange = (event) => {
    setNewDomainName(event.target.value);
  };

  const handleNewDecisionChange = (event) => {
    setNewDecision(event.target.value);
  };

  const handleDeleteDomain = async () => {
    const accessToken = localStorage.getItem("accessToken");

    try {
      if (
        window.confirm(
          `Are you sure you want to delete domain ${selectedDomain.domainname}? This cannot be undone!`
        )
      ) {
        const response = await axios.delete(
          `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}domains/${selectedDomain.domainid}/delete/`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        setSuccess(`Deleted ${selectedDomain.domainname}!`);

        setTimeout(() => {
          setSuccess(null);
        }, "2000");
      }
    } catch (error) {
      setDomainError("Error while deleting domain!");
      setTimeout(() => {
        setDomainError(null);
      }, "2000");
      console.error(
        "Error deleting domain:",
        error.response?.data || error.message
      );
    }
  };

  const handleNewDomain = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const data = {
      domainname: newDomainName,
      decisiontype2: newDecision,
      case_id: selectedCase.caseid,
    };

    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}domains/create/`,
        data,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setNewDecision(null);
      setNewDomainName(null);
      setSuccess("Domain Created");
      setTimeout(() => {
        setSuccess(null);
      }, "2000");
      setIsCreating(false);
    } catch (error) {
      setDomainError("Error while creating new domain!");
      console.error(
        "Error creating new domain:",
        error.response?.data || error.message
      );
      setTimeout(() => {
        setDomainError(null);
      }, "2000");
    }
  };

  return (
    <>
      <h5 className="uppercase text-[#ef8d23] font-bold">Case Domains</h5>
      {domainSuccess && <p>{domainSuccess}</p>}
      {domainError && <p>{domainError}</p>}
      {domains.map((item) => {
        return (
          <>
            {item.domainid === selectedDomain?.domainid ? (
              <>
                <div className="row mb-3">
                  <div className="col-1 text-center">
                    <i class="fa-solid fa-globe text-[#ef8d23]"></i>
                  </div>
                  <div className="col-5">
                    <input
                      value={domainName}
                      type="text"
                      className="border-bottom p-2 w-100"
                      onChange={(event) => handleDomainNameChange(event)}
                      />
                  </div>
                  <div className="col-4">
                    <select
                      value={decision}
                      onChange={(event) => handleDecisionChange(event)}
                      className="border p-2"
                      >
                      <option value="Transfer">Transfer</option>
                      <option value="Refused">Refused</option>
                      <option value="Settled">Settled</option>
                      <option value="Appeal-Upheld">Appeal-Upheld</option>
                      <option value="Appeal-Refuse">Appeal-Refuse</option>
                      <option value="Appeal-Transfer">Appeal-Transfer</option>
                      <option value="Appeal">Appeal</option>
                      <option value="Withdrawn">Withdrawn</option>
                      <option value="Pending">Pending</option>
                      <option value="Summary Decision - Transfer">
                        Summary Decision - Transfer
                      </option>
                      <option value="Summary Decision - Refused">
                        Summary Decision - Refused
                      </option>
                      <option value="Informal Mediation - Settled">
                        Informal Mediation - Settled
                      </option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </div>
                  <div className="col-2 flex justify-content-between">
                    <button
                      onClick={() => {
                        handleUpdate(
                          selectedDomain,
                          domainName,
                          decision,
                          setDomainError,
                          setSuccess
                        );
                        handleCloseInput(
                          setIsEditing,
                          setSelectedDomain,
                          setDomainName,
                          setDecision
                        );
                      }}
                    >
                      <i class="fa-solid fa-check ml-2 text-[#ef8d23]"></i>
                    </button>
                    <button
                      onClick={() => {
                        handleDeleteDomain();
                        handleCloseInput(
                          setIsEditing,
                          setSelectedDomain,
                          setDomainName,
                          setDecision
                        );
                      }}
                    >
                      <i class="fa-solid fa-trash ml-2 text-[#dc3545]"></i>
                    </button>
                    <button
                      onClick={() => {
                        handleCloseInput(
                          setIsEditing,
                          setSelectedDomain,
                          setDomainName,
                          setDecision
                        );
                      }}
                      >
                      <i class="fa-solid fa-xmark ml-2"></i>
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row mb-3">
                  <div className="col-1 text-center">
                    <i class="fa-solid fa-globe"></i>
                  </div>
                  <div className="col-5">{item.domainname}</div>
                  <div className="col-4">{item.decisiontype2}</div>
                  <div className="col-2 text-right">
                    <button
                      onClick={() =>
                        handleDisplayInput(
                          item,
                          setIsEditing,
                          setSelectedDomain,
                          setDomainName,
                          setDecision
                        )
                      }
                      >
                      <i class="fa-solid fa-pen-to-square ml-3"></i>
                    </button>
                  </div>
                </div>
              </>
            )}
          </>
        );
      })}
      {isCreating ? (
        <>
          <div className="row">
          <div className="col-1 text-center">
                    <i class="fa-solid fa-globe"></i>
                  </div>
            <div className="col-5">
               <input
              value={newDomainName}
              type="text"
              className="border-bottom p-2 w-100"
              onChange={(event) => handleNewDomainNameChange(event)}
              />
            </div>
            <div className="col-4">
              <select
              value={newDecision}
              onChange={(event) => handleNewDecisionChange(event)}
              className="border p-2"
              >
              <option value="Transfer">Transfer</option>
              <option value="Refused">Refused</option>
              <option value="Settled">Settled</option>
              <option value="Appeal-Upheld">Appeal-Upheld</option>
              <option value="Appeal-Refuse">Appeal-Refuse</option>
              <option value="Appeal-Transfer">Appeal-Transfer</option>
              <option value="Appeal">Appeal</option>
              <option value="Withdrawn">Withdrawn</option>
              <option value="Pending">Pending</option>
              <option value="Summary Decision - Transfer">
                Summary Decision - Transfer
              </option>
              <option value="Summary Decision - Refused">
                Summary Decision - Refused
              </option>
              <option value="Informal Mediation - Settled">
                Informal Mediation - Settled
              </option>
              <option value="Cancelled">Cancelled</option>
            </select>
            </div>
            <div className="col-2 flex justify-content-between">  <button
              onClick={handleNewDomain}
              className="ml-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
              >
              Add
            </button>
            <button
              onClick={() => {
                setIsCreating(false);
              }}
              >
              <i class="fa-solid fa-xmark ml-2"></i>
            </button></div>



          </div>
        </>
      ) : (
        <>
          <button
            className="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
            onClick={() => setIsCreating((prev) => !prev)}
            >
            Add Domain
          </button>
        </>
      )}

    </>
  );
}
